export default __webpack_public_path__ + "static/media/element_104.8f85d97b.avif";